export default __webpack_public_path__ + "static/launchpad_story-c14c0dbd1160a0cf8ad97be1d4922836.png";